import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'user-cell',
  templateUrl: './user-cell.component.html',
  styleUrl: './user-cell.component.scss',
  standalone: false,
})
export class UserCellComponent implements ICellRendererAngularComp {
  user: any;
  constructor() {}

  agInit(params: ICellRendererParams): void {
    this.user = params.data;
  }

  refresh(params: ICellRendererParams): boolean {
    this.user = params.data;
    return true;
  }
}
